import {
    CodeAssurance,
    TypeAssurance,
    IResumeOffre,
    IPret,
    TypeOffreTarification,
    ParcoursAssurance,
    IAssureResume
} from '../../../../hooks';

export const hasAlreadyAssurance = (codeAssurance: string): boolean => {
    return (
        codeAssurance === CodeAssurance.VIE ||
        codeAssurance === CodeAssurance.VIE_INVALIDITE ||
        codeAssurance === CodeAssurance.RETRAIT
    );
};

export const hasOffreSimulee = (typeOffreTarification: string): boolean => {
    return typeOffreTarification === TypeOffreTarification.SIMULEE;
};

export const hasSoumissionAssurance = (codeAssurance: string): boolean => {
    return codeAssurance === CodeAssurance.SOUMISSION_ASSURANCE;
};

export const mustFetchSoldeFinTerme = (resume: IResumeOffre): boolean => {
    return (
        !resume?.offreChoisie?.indicateurFinDeTerme &&
        hasSoumissionAssurance(resume?.assurance?.codeAssurance)
    );
};

export const hasCurrentlyAssurance = (codeAssurance: string): boolean => {
    return (
        codeAssurance === CodeAssurance.VIE ||
        codeAssurance === CodeAssurance.VIE_INVALIDITE ||
        codeAssurance === CodeAssurance.SOUMISSION_ASSURANCE
    );
};

export const getTypeAssurance = (pret: IPret): TypeAssurance => {
    return pret?.codeAssurance !== CodeAssurance.RETRAIT
        ? pret?.typeAssurance
        : TypeAssurance.NONE;
};

export const obtenirResumeAssuranceTitreSection = (
    resumeOffre: IResumeOffre
): string => {
    return resumeOffre?.assurance?.typeAssurance === TypeAssurance.AP ||
        resumeOffre?.assurance?.codeAdmissibleAssurance ===
            ParcoursAssurance.PARCOURS_3
        ? 'resumeAssuranceTitleAP'
        : 'resumeAssuranceTitleAPMat';
};

export const obtenirLibellePaiementInvalidite = (
    resumeOffre: IResumeOffre
): string => {
    return resumeOffre?.assurance?.typeAssurance === TypeAssurance.AP ||
        resumeOffre?.assurance?.codeAdmissibleAssurance ===
            ParcoursAssurance.PARCOURS_3
        ? 'resumeAssuranceInvaliditeTexte'
        : 'resumeAssuranceInvaliditeRequisTexte';
};

export const obtenirLibelleTypeProtectionAssurance = (
    assures: Array<IAssureResume>
): string => {
    let libelle = 'protection';

    if (assures?.length != 1) {
        return libelle;
    }

    const assure = assures[0];

    if (assure.pctCouvertureAssuranceVie == 100) {
        if (assure.pctCouvertureAssuranceInvalidite == 100) {
            libelle = 'protectionComplete';
        } else if (assure.pctCouvertureAssuranceInvalidite == 50) {
            libelle = 'protectionIntermediaire';
        } else if (assure.pctCouvertureAssuranceInvalidite == 0) {
            libelle = 'protectionVieSeulement';
        }
    }

    return libelle;
};
